import { pharmacyClient } from "@/connect";
import dayjs from "dayjs";

export const getPLReport = async (page: number, pageSize: number, startDate: string, endDate: string) => {
  return await pharmacyClient.pLReport({
    startDate: dayjs(startDate).startOf("day").unix(),
    endDate: dayjs(endDate).endOf("day").unix(),
    pageNumber: page,
    pageSize: pageSize,
  });
};